var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbroadYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8929_17914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9367 17.9881L19.8804 22.8308L18.9951 23.3829L17.9329 19.2379L15.5604 20.7177L15.6406 22.4705L14.9766 22.8846L14.1928 20.6692L12.5237 19.006L13.1877 18.5919L14.7432 19.4245L17.1157 17.9448L13.8168 15.1948L14.7021 14.6426L19.119 16.6952L21.5301 15.1915C21.7062 15.0816 21.9181 15.0444 22.1193 15.088C22.3205 15.1315 22.4944 15.2523 22.6028 15.4238C22.7113 15.5952 22.7453 15.8033 22.6974 16.0022C22.6496 16.2011 22.5238 16.3745 22.3477 16.4843L19.9367 17.9881Z",
    fill: "#FCD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 21.8813V3.32971C7 2.77771 7.448 2.32971 8 2.32971H16C16.552 2.32971 17 2.77771 17 3.32971V11.0819V13.0728M7 8.32971H3C2.448 8.32971 2 8.77771 2 9.32971V21.8813H11.3597M17 8.32971H21C21.552 8.32971 22 8.77771 22 9.32971V13.0728M10 9.82971H14M10 12.8297H14M10 6.82971H14M5 12.8297H7M5 16.3297H7",
    stroke: "#FCD700",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8929_17914"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbroadYellow);
export default __webpack_public_path__ + "static/media/abroad_yellow.4536d018cedf7e1179d2658c284c8045.svg";
export { ForwardRef as ReactComponent };